import React from "react";
import { Link } from "react-router-dom";
import { Link as RouterLink } from "react-router-dom";
import { BorderColor } from "@mui/icons-material";
import { Box, Typography, useTheme, Container, Paper } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Privacy Policy</h1>

        <p style={styles.paragraph}>
          By using OmneVu.com website and services you agree to our use of your
          personal information (including sensitive personal information) in
          accordance with this Privacy Notice, as may be amended from time to
          time by us at our discretion. You also agree and consent to us
          collecting, storing, processing, transferring, and sharing your
          personal information (including sensitive personal information) with
          third parties or service providers for the purposes set out in this
          Privacy Notice.
        </p>

        <p style={styles.paragraph}>
          We may automatically collect and store certain types of information
          about your use of OmneVu.com and its services, including information
          about your interaction with content and services available through
          OmneVu.com. We may use cookies and other unique identifiers, and we
          obtain certain types of information when your web browser or device
          accesses OmneVu.com and its services.
        </p>

        <p style={styles.paragraph}>
          We might receive information about you from other sources, such as
          updated delivery and address information from our carriers, which we
          use to correct our records and deliver your next purchase more easily.
        </p>

        <p style={styles.paragraph}>
          We use your personal information to operate, provide, develop, and
          improve the products and services that we offer our customers. These
          purposes include:
        </p>

        <ul style={styles.list}>
          <li>
            To take and fulfill orders, deliver products and services, process
            payments, and communicate with you about orders, products, services,
            and promotional offers.
          </li>
          <li>
            To provide functionality, analyze performance, fix errors, and
            improve the usability and effectiveness of OmneVu.com services.
          </li>
          <li>
            To recommend features, products, and services that might be of
            interest to you and personalize your experience.
          </li>
          <li>
            To comply with applicable laws and legal requirements.
          </li>
          <li>
            To communicate with you via phone, email, or chat regarding products
            and services.
          </li>
          <li>
            To display interest-based advertisements.
          </li>
          <li>
            To prevent and detect fraud and abuse and protect security.
          </li>
        </ul>

        <p style={styles.paragraph}>
          To enable our systems to recognize your browser or device and to
          provide and improve OmneVu.com services, we use cookies and other
          identifiers.
        </p>

        <p style={styles.paragraph}>
          <strong>Third-Party Advertisers and Links:</strong> OmneVu.com may
          include third-party advertising and links to other websites and apps.
          These third parties may collect information about you when you
          interact with their content.
        </p>

        <p style={styles.linkText}>
          View our{" "}
          <Link to="/third-party" style={styles.link}>
            Third-Party Software Licenses
          </Link>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f9f9f9",
    padding: "40px 0",
  },
  container: {
    maxWidth: "850px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    padding: "40px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.8",
    color: "#333",
  },
  heading: {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "32px",
    fontWeight: "600",
  },
  paragraph: {
    marginBottom: "20px",
    textAlign: "justify",
  },
  list: {
    marginLeft: "20px",
    marginBottom: "25px",
  },
  linkText: {
    marginTop: "30px",
    textAlign: "center",
  },
  link: {
    color: "#1976d2",
    textDecoration: "underline",
    fontWeight: "500",
  },
};

export default PrivacyPolicy;